import { TE } from '@packages/prelude'
import { ConfigurationData } from '~/types'

export const generatePDF = (configurationData: ConfigurationData): TE.TaskEither<Error, Blob> =>
  TE.tryCatch(
    () =>
      fetch('/wp-json/wp/v2/pdf/generate', {
        method: 'POST',
        headers: {
          'X-WP-Nonce': window.htcConfig.nonce,
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(configurationData)
      }).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        }
        return response.blob()
      }),
    error => new Error(`PDF generation failed: ${String(error)}`)
  )
